// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_PB_SET_TYPE,
} from './constants';

export function pbSetType(data) {
  return {
    type: HOME_PB_SET_TYPE,
    data:data
  };
} 

export function reducer(state, action) {
  switch (action.type) {
    case HOME_PB_SET_TYPE:
      return {
        ...state,
        pbSetType:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/pbSetType.js